import { combineReducers } from 'redux';
import { reducer as form } from 'redux-form';

import abTesting from './abTesting';
import accessControlReady from './accessControlReady';
import account from './account';
import accountSingleSignOn from './accountSingleSignOn';
import addRVtoSubscription from './addRVtoSubscription';
import alerts from './alerts';
import apiKeys from './api-keys';
import auth from './auth';
import billing from './billing';
import billingCreate from './billingCreate';
import blocklist from './blocklist';
import cookieConsent from './cookieConsent';
import currentUser from './currentUser';
import dataPrivacy from './dataPrivacy';
import dkimKeys from './dkimKeys';
import globalAlert from './globalAlert';
import ingestBatchEvents from './ingestBatchEvents';
import invoices from './invoices';
import ipPools from './ipPools';
import messageEvents from './messageEvents';
import metrics from './metrics';
import passwordReset from './passwordReset';
import recipientLists from './recipientLists';
import recipientValidation from './recipientValidation';
import reports from './reports';
import scimToken from './scimToken';
import sendingDomains from './sendingDomains';
import sendingIps from './sendingIps';
import signalOptions from './signalOptions';
import signals from './signals';
import snippets from './snippets';
import subaccounts from './subaccounts';
import summaryTables from './summaryTables';
import support from './support';
import suppressions from './suppressions';
import templates from './templates';
import tfa from './tfa';
import tfaBackupCodes from './tfaBackupCodes';
import trackingDomains from './trackingDomains';
import typeahead from './typeahead';
import usage from './usage';
import users from './users';
import webhooks from './webhooks';
import websiteAuth from './websiteAuth';

const appReducer = combineReducers({
  abTesting,
  accessControlReady,
  account,
  accountSingleSignOn,
  addRVtoSubscription,
  alerts,
  apiKeys,
  auth,
  billing,
  billingCreate,
  blocklist,
  cookieConsent,
  currentUser,
  dataPrivacy,
  dkimKeys,
  scimToken,
  globalAlert,
  form,
  invoices,
  ingestBatchEvents,
  ipPools,
  metrics,
  messageEvents,
  passwordReset,
  reports,
  recipientLists,
  recipientValidation,
  sendingDomains,
  sendingIps,
  signalOptions,
  signals,
  snippets,
  subaccounts,
  support,
  summaryTables,
  suppressions,
  templates,
  tfa,
  tfaBackupCodes,
  trackingDomains,
  typeahead,
  usage,
  users,
  webhooks,
  websiteAuth
});

/**
 * Resets state to initial values on log out
 */
export default (state, action) => {
  if (action.type === 'LOGOUT') {
    state = undefined;
  }

  return appReducer(state, action);
};
